import { Inject, Injectable } from '@angular/core';
import { ApiCommonService } from 'cbc-shared-lib';
import { TimeApiService } from 'cbc-shared-lib';
import { Subject, Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';
import { SGKC026AService, Sgkc026aRequest, Sgkc026aResponse } from 'sg-api';

/**
 * 単価表承認権限取得API使用サービス
 * @export
 * @class UsedSgkc026aService
 */
@Injectable({
    providedIn: 'root'
})
export class UsedSgkc026aService {

    /**単価表承認権限取得結果の結果のSubject */
    private _tankatableAuthorityInformationResult$: Subject<Sgkc026aResponse> = new Subject<Sgkc026aResponse>();

    /**
   * コンストラクタ
   * @param {SGKC026AService} sGKC026AService
   * @param {ApiCommonService} apiCommonService
   * @param {TimeApiService} timeApiService
   * @param {FeaturesLibConfig} featuresLibConfig
   * @memberof UsedSgkc026aService
   */
    constructor(
        private sGKC026AService: SGKC026AService,
        private apiCommonService: ApiCommonService,
        private timeApiService: TimeApiService,
        @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig
    ) { }

    /**
     * 単価表承認権限取得結果のobservable提供
     * @readonly
     * @memberof UsedSgkc026aService
     */
    get tankatableAuthorityChanges() {
        return this._tankatableAuthorityInformationResult$.asObservable();
    }

    /**
   * 単価表承認権限取得API呼び出し
   * @param {Sgkc026aRequest} value - 単価表承認権限取得リクエスト
   * @return {Observable<Sgkc026aResponse>} 単価表承認権限取得レスポンス
   * @memberof UsedSgkc026aService
   */
    getTankatableAuthorityInf(value: Sgkc026aRequest): Observable<Sgkc026aResponse> {
        // 年月日項目のフォーマット
        this.apiCommonService.convertElementInObject(value, Object.prototype.toString.call(new Date()), this.timeApiService.convertDateToString);
        // 検索条件を保存
        return this.sGKC026AService.kC10RSGKC026APost(<Sgkc026aRequest>this.apiCommonService.setRequestCommon(value), 'response')
            .pipe(
                map(response => {
                    // エラーが設定されていないかチェックする
                    this.apiCommonService.checkError(response);
                    this._tankatableAuthorityInformationResult$.next(response.body);
                    return response.body;
                }),
                timeout(Number(this.featuresLibConfig.httpTimeout)),
                catchError((err) => {
                    this.apiCommonService.dispErrorMessage(err, 'sgkc', 'SGKC026A');
                    return throwError(err.message);
                })
            );
    }
}
